<template>
  <div id="simple-edit">
    {{ prevRoute }}
    <input v-model="feederId_tmp" placeholder="feeder" class="form-control" />
    <button class="btn btn-primary" @click="addFeeder">Add Feeder</button>
    <button class="btn btn-primary" @click="removeFeeder">Remove Feeder</button>
    <form :action="urlToSubmit" method="POST" class="mt-4">
      <input class="btn btn-outline-primary" type="submit" value="submit" />

  

      <div class="form-group" v-for="(m, i) in myData" :key="i">
        <label>{{ i }}</label>
        <input class="form-control" :name="i" placeholder="Enter " :value="m" />
      </div>
      <input class="btn btn-outline-primary" type="submit" value="submit" />
    </form>
    <ul></ul>
  </div>
</template>

<script>
import { ApiTls } from "../app/tools/ApiTls";
import { UrlTls } from '../app/tools/UrlTls';
// this.$route.params.feederId
// /simple-edit/:tableName/:whereName/:whereValue

export default {
  name: "SimpleEdit",
  data() {
    return {
      myData: {},
      prevRoute: null,
   
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  methods: {
    saveData(res) {
      this.myData = res.data[0];
    },
    sentData() {},
    addFeeder() {
      if (this.myData.feeder_id_arr && this.feederId_tmp.length > 0) {
        this.myData.feeder_id_arr = this.myData.feeder_id_arr
          .split("_")
          .concat(this.feederId_tmp)
          .join("_");
        this.feederId_tmp = "";
      }
    },
    removeFeeder() {
      if (this.myData.feeder_id_arr) {
        this.myData.feeder_id_arr = this.myData.feeder_id_arr
          .split("_")
          .filter((r) => r & (r != this.feederId_tmp))
          .join("_");
        this.feederId_tmp = "";
      }
    },
  },
  computed: {
    urlToSubmit() {
      return (
        UrlTls.getBaseUrl()+"/free/" +
        this.$route.params.tableName +
        "/" +
        this.$route.params.whereName +
        "/" +
        this.$route.params.whereValue
      );
    },
  },
  mounted() {
    ApiTls.getFreeData(
      this.$route.params.tableName,
      this.$route.params.whereName,
      this.$route.params.whereValue,
      this.saveData
    );
  },
};
</script>

<style>
</style>